module.exports = __webpack_public_path__ + "static/media/18629a56-2ec3-4470-a65f-f82d7ec4d41b.cbca3e0e.woff2";